<div class="page-detail-wrap vetro-master-bg">
    <h5>{{modalTitle}}</h5>
</div>
<div class="vetro-bg">
    <div class="p-field form-group">
        <div class="row">
            <div class="col-md-6 mb-2">
                <label for="name" style="font-size: medium;">{{"common.name"
                    |translate}}</label>
                <input type="text" pInputText id="name" [(ngModel)]="model.name" #name="ngModel" required />
            </div>
            <div class="col-md-6 mb-2">
                <label for="country" style="font-size: medium;">Publishing Country</label>
                <input type="text" pInputText id="country" [(ngModel)]="model.publishingCountry" maxlength="2"
                    onkeydown="return /[a-zA-Z]/i.test(event.key)" #country="ngModel" required />
            </div>
            <div class="col-md-12 mt-2">
                <label for="title" style="font-size: medium;">Title</label>
                <textarea id="title" #description="ngModel" pInputTextarea [(ngModel)]="model.title" name="title"
                    placeholder="Title"></textarea>
            </div>
            <div class="col-md-6 mb-2">
                <label for="country" style="font-size: medium;">Performance Criteria</label>
                <p-listbox
                    [options]="performanceCriteriaList"
                    [(ngModel)]="model.performanceCriteria"
                    optionLabel="name"
                    optionValue="id"
                    [multiple]="true"
                    [checkbox]="true"
                    [filter]="true"
                    [listStyle]="{'max-height':'250px'}"
                    [style]="{'width':'15rem'}">
                </p-listbox>

            </div>
            <div class="col-md-5">
                <span class="tag" *ngFor="let c of model.performanceCriteria" style="margin-right: 10px">
                    {{selectedStandards(c)}}
                    <a class="pi pi-times-circle" (click)="delete(c,model)"></a>
                </span>
            </div>
            {{performanceCriteria}}
        </div>
    </div>
    <div class="grid grid-nogutter d-flex justify-content-end">
        <button pButton pRipple label="{{'commonbtn.save'|translate}}" icon="pi pi-check" styleClass="btn-save"
        (click)="save(model)"></button>        
            
    </div>
</div>